<template>
  <div id="team-members-modifiy">
    <v-card style="height: 100vh; width: 100vw; overflow-y: auto">
      <v-app-bar
        color="primary"
        dense
        dark
        elevate-on-scroll
        scroll-target="#scrolling-techniques-7"
      >
        <v-toolbar-title> {{ PageTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closePrompt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-form ref="form1" v-model="valid1" lazy-validation id="createForm">
        <v-card-text style="height: 70%">
          <v-container class="py-0">
            <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
              <b-spinner
                variant="primary"
                type="grow"
                label="Loading..."
              ></b-spinner>
            </div>
            <v-container v-if="StartupLoadingFlag">
              <v-row wrap>
                <v-col cols="12" md="4" v-for="n in 6" :key="n">
                  <v-skeleton-loader
                    v-bind="attrs"
                    type="paragraph"
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
            </v-container>
            <v-row wrap v-if="ProgessStart == 1">
              <v-col align="center" cols="12" md="12">
                <v-progress-circular
                  :rotate="180"
                  :size="100"
                  :width="15"
                  :value="uploadPercentage"
                  color="#00a4ef"
                >
                  {{ uploadPercentage }}
                </v-progress-circular>
                <h3 class="red--text">
                  Please wait, we are uploading your details. Time may vary
                  based on your internet connection.
                </h3>
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="!StartupLoadingFlag">
            <v-row wrap>
              <v-col cols="12" sm="6" lg="3" md="3">
                <label>
                  <h6><span class="text-danger">*</span> <b>Zone</b></h6>
                </label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  v-model="ZoneCode"
                  :rules="ZoneCodeRules"
                  :items="ZoneCodeOptions"
                  :loading="ZoneCodeOptionsLoading"
                  dense
                  clearable
                  required
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <label>
                  <h6><span class="text-danger">*</span> LO</h6>
                </label>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="LomCodeOptionsLoading"
                  :items="LomCodeOptions"
                  :rules="LomCodeRules"
                  v-model="LomCode"
                  required
                  outlined
                  dense
                  clearable
                >
                </v-autocomplete>
              </v-col>

              <!-- Conference From Date -->
              <v-col cols="12" sm="6" lg="3" md="3">
                <label
                  ><h6>
                    <span class="text-danger">*</span> Conference Start Date
                  </h6></label
                >
                <v-menu
                  v-model="ConferenceFromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  full-width
                  :nudge-right="40"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      required
                      v-model="ConferenceFromDate"
                      label="Select Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      validate-on-blur
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="ConferenceFromDate"
                    @input="ConferenceFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <!-- Conference To Date -->
              <v-col cols="12" sm="6" lg="3" md="3">
                <label
                  ><h6>
                    <span class="text-danger">*</span> Conference End Date
                  </h6></label
                >
                <v-menu
                  v-model="ConferenceToMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  full-width
                  :nudge-right="40"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="ConferenceToDate"
                      label="Select Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      validate-on-blur
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="ConferenceToDate"
                    @input="ConferenceToMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <!-- Nomination Conference From Date -->
              <v-col cols="12" sm="6" lg="3" md="3">
                <label
                  ><h6>
                    <span class="text-danger">*</span> Nomination Start Date
                  </h6></label
                >
                <v-menu
                  v-model="NominationConfFromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  full-width
                  :nudge-right="40"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="NominationConfFromDate"
                      label="Select Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      validate-on-blur
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="NominationConfFromDate"
                    @input="NominationConfFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <!-- Nomination Conference To Date -->
              <v-col cols="12" sm="6" lg="3" md="3">
                <label
                  ><h6>
                    <span class="text-danger">*</span> Nomination End Date
                  </h6></label
                >
                <v-menu
                  v-model="NominationConfToMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  full-width
                  :nudge-right="40"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="NominationConfToDate"
                      label="Select Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      validate-on-blur
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="NominationConfToDate"
                    @input="NominationConfToMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <!-- Award From Date -->
              <v-col cols="12" sm="6" lg="3" md="3">
                <label
                  ><h6>
                    <span class="text-danger">*</span> Award Bidding Start Date
                  </h6></label
                >
                <v-menu
                  v-model="AwardFromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  full-width
                  :nudge-right="40"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="AwardFromDate"
                      label="Select Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      validate-on-blur
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="AwardFromDate"
                    @input="AwardFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <!-- Award To Date -->
              <v-col cols="12" sm="6" lg="3" md="3">
                <label
                  ><h6>
                    <span class="text-danger">*</span> Award Bidding End Date
                  </h6></label
                >
                <v-menu
                  v-model="AwardToMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  full-width
                  :nudge-right="40"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="AwardToDate"
                      label="Select Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      validate-on-blur
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="AwardToDate"
                    @input="AwardToMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="6" lg="3" md="3">
                <label
                  ><h6>
                    <span class="text-danger">*</span>Election Officer
                    Membership ID
                  </h6></label
                >
                <v-row dense>
                  <v-col cols="8">
                    <v-text-field
                      v-model="MemberId"
                      :rules="MemberIdRules"
                      dense
                      outlined
                      required
                      clearable
                      type="number"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="2">
                    <v-btn
                      color="green"
                      class="mt-1"
                      block
                      dark
                      @click="getMemberRecords"
                      small
                    >
                      Search
                    </v-btn>
                  </v-col>
                </v-row>
                <v-card
                  v-if="member.MemberName"
                  class="mt-3 pa-4 elevation-10"
                  color="#f3f5ff"
                  style="
                    border-radius: 12px;
                    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
                  "
                >
                  <v-row no-gutters align="center">
                    <v-col cols="3">
                      <v-img
                        :src="member.Photo"
                        height="90"
                        width="90"
                        contain
                        class="rounded-circle elevation-5"
                        v-if="member.Photo"
                      ></v-img>
                      <v-avatar size="100" v-else>
                        <v-icon large color="grey">mdi-account</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="9">
                      <div class="text-subtitle-1 font-weight-bold mb-1">
                        {{ member.MemberName }}
                        <span class="text--secondary"
                          >({{ member.MembershipId || "NA" }})</span
                        >
                      </div>
                      <div><b>DOB:</b> {{ member.MemberDOB || "NA" }}</div>
                      <div><b>Email:</b> {{ member.EmailId || "NA" }}</div>
                      <div><b>Mobile:</b> {{ member.MobileNo || "NA" }}</div>
                      <div><b>Address:</b> {{ member.AddressTxt || "NA" }}</div>
                      <div class="mt-1">
                        <b>Aadhaar Verification:</b>
                        <v-chip
                          :color="member.AadhaarTextColor"
                          dark
                          small
                          class="ml-2"
                        >
                          {{ member.AadhaarVerifiedTxt }}
                        </v-chip>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <br /><br />
        <v-card-actions>
          <v-row justify="center" class="w-100">
            <v-btn
              @click.prevent="confirmAlert"
              :loading="SubmitFlag"
              elevation="30"
              shaped
              tile
              small
              color="primary"
              class="font-size-h6 px-10 mr-3 white--text"
            >
              submit
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import UploadSelectedMemberDocument from "@/view/pages/members/UploadSelectedMemberDocument.vue";
import UploadSelectedMemberPhoto from "@/view/pages/members/UploadSelectedMemberPhoto.vue";

export default {
  mixins: [common],
  components: {
    UploadSelectedMemberDocument,
    UploadSelectedMemberPhoto,
  },
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,

      search: "",
      selected: [],
      tableSelectFlag1: false,
      SubmitFlag: false,
      ResultFlag: false,

      ConferenceFromDate: "",
      ConferenceToDate: "",
      ConferenceFromMenu: false,
      ConferenceToMenu: false,

      NominationConfFromDate: "",
      NominationConfToDate: "",
      NominationConfFromMenu: false,
      NominationConfToMenu: false,

      AwardFromDate: "",
      AwardToDate: "",
      AwardFromMenu: false,
      AwardToMenu: false,

      member: {},

      NominationDesignationOptions: [],
      NominationDesignationRules: [
        (v) => !!v || "Nomination Designation is required",
      ],
      NominationDesignationOptionsLoading: false,
      NominationDesignation: "", // not null or undefined

      memberDocumentPrompt: false,
      memberPhotoPrompt: false,

      rows: [],
      tableColumns1: [],
      records: [],

      alert: {},

      ProgessStart: 0,
      uploadPercentage: 0,

      SuccessMessageTxtFlag: 0,
      SuccessMessageTxt: "",

      ErrorMessageTxtFlag: 0,
      ErrorMessageTxt: "",

      ResultFlag: false,
      LoadingFlag: false,
      StartupLoadingFlag: false,

      AllMembers: [],

      LomCodeRules: [(v) => !!v || "LO is required"],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      MemberIdRules: [(v) => !!v || "Membership ID is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",

      ZoneCodeRules: [],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,
    };
  },
  computed: {},
  watch: {
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.LoadingFlag = false;
      this.ZoneCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode");
      // this.getRegionCodeOptions();
      this.LomCode = "";
      this.getLomCodeOptions();
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LoadingFlag = false;
      this.LomCodeOptionsLoading = false;
    },
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.pageData();
      }
    },
    rows: function () {
      console.log("watch rows");
      var n1 = this.rows.length;
      var flag = n1 == 0 ? 0 : 1;
      console.log("n1=" + n1 + ", flag=" + flag);
      this.records = this.rows[0];
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "conference_settings",
        Action: "create_2",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      this.pageData();
    },
    pageData() {
      console.log("pageData called");
      console.log("LomCode=" + this.LomCode);
      console.log("ZoneCode=" + this.ZoneCode);
      this.getZoneCodeOptions();
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        this.LoadingFlag = true;
        this.ZoneCodeOptionsLoading = true;
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var YearCode = this.JciYearCode;
      var ZoneCode = this.ZoneCode;
      var RegionCode = this.RegionCode;
      console.log(
        "YearCode=" +
          YearCode +
          ", ZoneCode=" +
          ZoneCode +
          ", RegionCode=" +
          RegionCode
      );
      if (YearCode != "" && ZoneCode != "") {
        this.LoadingFlag = true;
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getMemberRecords() {
      console.log("getMemberRecords called");

      var MemberId = this.MemberId;
      console.log({ MemberId });

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/nominate-member-subscription/info";
      var upload = {
        UserInterface: 2,
        Membership: MemberId,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );
      console.log("recordData:", this.recordData);

      const thisIns = this;
      var output = "";
      var records = {};
      var flag = 0;
      var data = {};

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.LoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.member = records;
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.LoadingFlag = false;
        });
    },
    validate() {
      console.log("validate called");
      this.$refs.form1.validate();
    },
    reset() {
      console.log("reset called");
      this.$refs.form1.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt", this.ResultFlag);
    },
    resetMessageTxt() {
      console.log("resetMessageTxt called");
      this.ErrorMessageTxt = 0;
      this.ErrorMessageTxtFlag = "";
      this.SuccessMessageTxtFlag = 0;
      this.SuccessMessageTxt = "";
    },
    onFileSelected(event, k) {
      console.log("onFileSelected called");
      var n1 = this.uploadedImages.length;
      var file = event.target.files[0];
      console.log("k=" + k + ", event=" + JSON.stringify(file));
      this.uploadedImages[k] = file;
    },
    addNewRow(tableId) {
      console.log("addNewRow called");
      console.log("tableId=" + tableId);

      if (tableId == 2) {
        var n1 = this.AllMembers.length;
        console.log("n1=" + n1);
        // if (n1 < 30) {
        this.AllMembers.push({
          YearwiseOfficesHeldId: null,
          MemberId: 0,
          MemberName: "",
          NominationDesignation: 0,
          Designation: "",
        });
        // }
      }
    },
    deleteRow(tableId, index, tr) {
      console.log("deleteRow called");
      console.log(
        "tableId=" + tableId + ", index=" + index + ", tr=" + JSON.stringify(tr)
      );
      if (index > -1) {
        if (tableId == 2) {
          this.AllMembers.splice(index, 1);
        }
      }
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 7,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      // add todo in store and clear all fields in dialog
      console.log("submitForm called");

      // this.resetMessageTxt();
      var MemberId = this.member.MemberId;
      console.log("MemberId=" + MemberId);

      var result = this.$refs.form1.validate();
      console.log("result=" + result);

      if (result && MemberId !== "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/nomination-conference/store";
        var upload = {
          UserInterface: 1,
          Lom: this.LomCode,
          Zone: this.ZoneCode,
          ConferenceStartDate: this.ConferenceFromDate,
          ConferenceEndDate: this.ConferenceToDate,
          NominationStartDate: this.NominationConfFromDate,
          NominationEndDate: this.NominationConfToDate,
          AwardBiddingStartDate: this.AwardFromDate,
          AwardBiddingEndDate: this.AwardToDate,
          MembershipId: this.MemberId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.LoadingFlag = true;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        // thisIns.pageLoadingOn()

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            // thisIns.ProgessStart = 0;
            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              // thisIns.SuccessMessageTxtFlag = 1;
              // thisIns.SuccessMessageTxt = output;
              thisIns.ResultFlag = true;
              thisIns.closePrompt();
              // thisIns.AllMembers = [];
              // thisIns.ResultFlag = false;
              thisIns.sweetAlert("success", output, true);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.LoadingFlag = false;
          });
      } else {
        console.log("some errors occured");
        var message = "";
        if (!this.ZoneCode || !this.LomCode || !MemberId) {
          message += "Please search the Member Id and Submit";
        }

        if (message !== "") {
          this.sweetAlert("error", message, false);
        }
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
#team-members-modifiy {
  .v-dialog > .v-card > .v-toolbar {
    position: sticky;
    top: 0;
    z-index: 999;
  }
  .date-field {
    max-width: 300px;
    margin-bottom: 10px;
  }
  .v-card {
    border-radius: 12px;
  }

  .v-card .text-subtitle-1 {
    font-size: 1.2rem;
  }

  .v-card .v-chip {
    font-size: 0.9rem;
  }
}
</style>